var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.676392 6.99979C0.676392 6.6316 0.974868 6.33312 1.34306 6.33312H12.6568C13.025 6.33312 13.3234 6.6316 13.3234 6.99979C13.3234 7.36798 13.025 7.66646 12.6568 7.66646H1.34306C0.974868 7.66646 0.676392 7.36798 0.676392 6.99979Z",
    fill: "#191818",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99991 0.67627C7.3681 0.676269 7.66658 0.974746 7.66658 1.34294V12.6566C7.66658 13.0248 7.3681 13.3233 6.99991 13.3233C6.63172 13.3233 6.33325 13.0248 6.33325 12.6566V1.34294C6.33325 0.974746 6.63172 0.676269 6.99991 0.67627Z",
    fill: "#191818",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d7806020e14eeb8b33ef81c424f34e19.svg";
export { ForwardRef as ReactComponent };